export * from './layout';

import _UserDefaultImage from '../assets/images/users/default.webp';

export const UserDefaultAvatar = _UserDefaultImage;
export * from './calendar-translations';
